/**
 * Question Header Component
 * Single Responsibility: Renders the header section with icon, title, and close button
 *
 * Best Practice: Uses regular <img> tag for SVG icons instead of Next.js Image
 * because SVGs don't need optimization and load faster from browser cache
 */

import React from 'react';
import { spacing, typographyColors, typography } from '@/design-system/utils';
import { CloseButton } from '@/components/common/CloseButton';

export interface QuestionHeaderProps {
  title: string;
  onClose?: () => void;
}

/**
 * Question Header Component
 * Displays the header with bulb icon, title, and optional close button
 */
export const QuestionHeader: React.FC<QuestionHeaderProps> = ({
  title,
  onClose,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: spacing[0.5],
        width: '100%',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: spacing[2],
        }}
      >
        {/* Bulb Icon */}
        <div
          style={{
            width: '20px',
            height: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {/* Using regular img tag for SVG icons (best practice) */}
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src='/assets/images/icons/bulb.svg'
            alt='Questions'
            width={20}
            height={20}
          />
        </div>
        <h3
          style={{
            fontFamily: typography.fonts.primary,
            fontSize: typography.size.xs,
            fontWeight: typography.weight.bold,
            color: typographyColors.text,
            textAlign: 'center',
            lineHeight: 'normal',
            margin: 0,
          }}
        >
          {title}
        </h3>
      </div>
      {/* Close Icon */}
      {onClose && (
        <CloseButton
          onClick={onClose}
          size={20}
          ariaLabel='Close questions'
          variant='default'
        />
      )}
    </div>
  );
};
